const styles = theme => ({
  icon: props => ({
    color: theme.palette.common.white,
    backgroundColor: props.iconColor || theme.palette.primary.dark,
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 2,
    width: theme.spacing(4),
    ...theme.typography.caption
  })
});

export default styles;
